import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('method', 'Method', METHOD_OPTIONS)
      .multi(true),
    filter
      .options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter.boolean('active', 'Active'),
  ], [])
}

const METHOD_OPTIONS = [
  { label: 'GET', value: 'get' },
  { label: 'POST', value: 'post' },
]

const TYPE_OPTIONS = [
  { label: "Local", value: "local" },
  { label: "Gateway", value: "gateway" },
]
